import api from "@/core/api";

export const list = (document_type: string, field: string) => api.query(`/templates/list/${document_type}/${field}`);
